module.exports = __webpack_public_path__ + "media/ada-post2.13b3b63d.mp4";